// import React, { useState } from 'react';
// import { Field } from 'react-final-form';
// import classNames from 'classnames';
// import css from './CustomColorField.module.css';
// import multiImage from '../../assets/multi.png';
// const colorBlack = ['white', 'grey', 'beige', 'yellow', 'other', 'silver', 'gold'];

// const CustomColorField = ({ userTypeConfig = [], name, changeForm }) => {
//   if (userTypeConfig.length === 0) return null;

//   return (
//     <Field name={name}>
//       {({ input }) => {
//         const [selectedColors, setSelectedColors] = useState(input.value || []);
//         const handleSelection = key => {
//           let updatedSelection;
//           if (key === 'multicolored' || key === 'other') {
//             // If 'multicoloured' or 'other' is selected, clear all and set only the selected key
//             updatedSelection = [key];
//           } else {
//             // If any other color is selected, remove 'multicoloured' or 'other' and handle normally
//             updatedSelection = selectedColors.filter(
//               item => item !== 'multicolored' && item !== 'other'
//             );

//             if (selectedColors.includes(key)) {
//               // If the color is already selected, remove it
//               updatedSelection = updatedSelection.filter(item => item !== key);
//             } else if (updatedSelection.length < 2) {
//               // Add the color if fewer than two are selected
//               updatedSelection.push(key);
//             }
//           }

//           setSelectedColors(updatedSelection);
//           input.onChange(updatedSelection); // Update Final Form input
//           changeForm(updatedSelection); // Notify parent component
//         };

//         const typeButtons = userTypeConfig.map(item => {
//           const isActive = selectedColors.includes(item.key);
//           const classes = isActive
//             ? classNames(css.typeButtonActive, item.key === 'multicolored' ? css.multi : css.colour)
//             : item.key === 'multicolored'
//             ? css.multi
//             : css.colour;

//           return (
//             <div
//               className={classes}
//               key={item.key}
//               onClick={() => handleSelection(item.key)}
//               style={
//                 item.key === 'multicolored'
//                   ? { backgroundImage: `url(${multiImage})`, backgroundSize: 'cover' }
//                   : {
//                       background:
//                         item.key == 'silver'
//                           ? 'linear-gradient(175deg, #e0e0e0, #b3b3b3, #e0e0e0)'
//                           : item.key,
//                       color: colorBlack.includes(item.key) ? 'black' : 'white',
//                     }
//               }
//             >
//               <p className={css.label}>{item.key === 'multicolored' ? '' : item.label}</p>
//             </div>
//           );
//         });

//         return <div className={css.colourContainer}>{typeButtons}</div>;
//       }}
//     </Field>
//   );
// };

// export default CustomColorField;
import React, { useState } from 'react';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import css from './CustomColorField.module.css';
import multiImage from '../../assets/multi.png';
const colorBlack = ['white', 'grey', 'beige', 'yellow', 'other', 'silver', 'gold'];

const CustomColorField = ({ userTypeConfig = [], name, changeForm }) => {
  if (userTypeConfig.length === 0) return null;

  // Validation function
  const validate = value => (value && value.length > 0 ? undefined : 'Required');

  return (
    <Field name={name} validate={validate}>
      {({ input, meta }) => {
        const [selectedColors, setSelectedColors] = useState(input.value || []);
        const handleSelection = key => {
          let updatedSelection;
          if (key === 'multicolored' || key === 'other') {
            // If 'multicoloured' or 'other' is selected, clear all and set only the selected key
            updatedSelection = [key];
          } else {
            // If any other color is selected, remove 'multicoloured' or 'other' and handle normally
            updatedSelection = selectedColors.filter(
              item => item !== 'multicolored' && item !== 'other'
            );

            if (selectedColors.includes(key)) {
              // If the color is already selected, remove it
              updatedSelection = updatedSelection.filter(item => item !== key);
            } else if (updatedSelection.length < 2) {
              // Add the color if fewer than two are selected
              updatedSelection.push(key);
            }
          }

          setSelectedColors(updatedSelection);
          input.onChange(updatedSelection); // Update Final Form input
          changeForm(updatedSelection); // Notify parent component
        };

        const typeButtons = userTypeConfig.map(item => {
          const isActive = selectedColors.includes(item.key);
          const classes = isActive
            ? classNames(css.typeButtonActive, item.key === 'multicolored' ? css.multi : css.colour)
            : item.key === 'multicolored'
            ? css.multi
            : css.colour;

          return (
            <div
              className={classes}
              key={item.key}
              onClick={() => handleSelection(item.key)}
              style={
                item.key === 'multicolored'
                  ? { backgroundImage: `url(${multiImage})`, backgroundSize: 'cover' }
                  : {
                      background:
                        item.key === 'silver'
                          ? 'linear-gradient(175deg, #e0e0e0, #b3b3b3, #e0e0e0)'
                          : item.key,
                      color: colorBlack.includes(item.key) ? 'black' : 'white',
                    }
              }
            >
              <p className={css.label}>{item.key === 'multicolored' ? '' : item.label}</p>
            </div>
          );
        });

        return (
          <div>
            <div className={css.colourContainer}>{typeButtons}</div>
            {meta.touched && meta.error && <span className={css.error}>{meta.error}</span>}
          </div>
        );
      }}
    </Field>
  );
};

export default CustomColorField;
